var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.34315 0.92888L14.7071 7.29284C15.0976 7.68336 15.0976 8.31653 14.7071 8.70705L8.34315 15.071C7.95262 15.4615 7.31946 15.4615 6.92893 15.071C6.53841 14.6805 6.53841 14.0473 6.92893 13.6568L11.5858 8.99995H0V6.99995H11.5858L6.92893 2.34309C6.53841 1.95257 6.53841 1.3194 6.92893 0.92888C7.31946 0.538355 7.95262 0.538355 8.34315 0.92888Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"aria-hidden":"true","viewBox":"0 0 15 16","width":"100%","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
